import React, { useReducer } from 'react'

import filterContext from './context'

import initialState from './initial-state'

import searchReducer from './reducer'

interface IProps {
  children: React.ReactNode
}

const FilterProvider = ({ children }: IProps) => {
  const [filter, filterDispatch] = useReducer(searchReducer, initialState)

  return (
    <filterContext.Provider value={{ filter, filterDispatch }}>
      {children}
    </filterContext.Provider>
  )
}

export default FilterProvider
